<template>
    <div class="registration">
        <b-row>
            <b-col cols="7">
                <h6 class="mb-1"><i class="fas fa-fw mr-3" :class="{'fa-check': registration.po_pending === 'false', 'fa-ban': registration.po_pending === 'true'}"></i>{{registration.last_name}}, {{registration.first_name}}</h6>
                <div class="date"><i class="far fa-fw mr-3"></i> {{registration.created_at | moment('MMM D, YYYY')}} ({{registration.code}})</div>
                <div class="date"><i class="far fa-fw mr-3"></i> <span v-if="registration.district">{{registration.district.name}}</span><span v-if="registration.district && registration.school">, </span><span v-if="registration.school">{{registration.school.SchoolName}}</span></div>
                <div class="date" v-if="registration.total_paid"><i class="far fa-fw mr-3"></i> {{registration.total_paid | currency}} by <span v-if="registration.payment_type === 'cc'">Credit Card</span><span v-if="registration.payment_type === 'po'">Purchase Order</span></div>
            </b-col>
            <b-col class="text-right">
                <b-button variant="danger" :to="{name: 'reg-po', params: {id: conference.id, code: registration.code_secret}}" v-if="registration.po_pending === 'true'" class="mr-2"><i class="fas fa-money-check-edit mr-2"></i> Manage P.O.</b-button>
                <b-button variant="success" :to="{name: 'conf-registration', params: {id: conference.id, code: registration.code_secret}}"><i class="fas fa-search mr-2"></i> Details</b-button>
            </b-col>
        </b-row>
    </div>
</template>

<script>
    import {mapActions} from 'vuex';

    export default {
        name: "RegistrationRow",
        props: ['conference', 'registration'],
        methods: {
            ...mapActions(['activateReg']),

            activate: function(reg) {
                if (window.confirm('Are sure you are ready to activate and complete this registration?  The purchase order process should be complete before activating.')) {
                    reg.po_pending = 'false';
                    this.activateReg(reg.code)
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .registration {
        padding: 1rem;
        margin-bottom: 0.2rem;

        .date {
            font-size: 0.8rem;
            color: #333;
        }

        .fa-ban {
            color: red !important;
        }
    }
</style>